module.exports = __webpack_public_path__ + "static/media/cashflow_icon.5dcd3ab8.svg";